<template>
    <div>
        <div>
            <validation-observer ref="AddTemplateForm" #default="{ invalid }">
                <b-form @submit.prevent="formSubmitted">
                    <b-row>
                        <b-col md="12">
                            <b-form-group label="Template Name" label-for="mc-Template-name">
                                <validation-provider #default="{ errors }" name="Name" vid="Name" rules="required">
                                    <b-form-input id="mc-Template-name" placeholder="Template Name"
                                        v-model="template.name" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group label="Platform Type" label-for="platform-type00" readonly>
                                <validation-provider rules="required" #default="{ errors }" name="Platform Type" vid="Platform Type">
                                    <v-select
                                        v-model="template.platformType"
                                        :options="platformTypes"
                                        label="text"
                                        multiple
                                        :clearable="false"
                                        class="item-selector-title"
                                        placeholder="Select Platform Type"
                                        :state="errors.length > 0 ? false : null"
                                        disabled
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        
                        <b-col cols="12" class="mb-2">
                            <b-form-group label="Subject" label-for="textarea-default">
                                <validation-provider #default="{ errors }" name="Subject" vid="Subject" >
                                    <b-form-input id="textarea-default" type="text" placeholder="Subject"
                                        v-model="template.subject" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" class="mb-2">
                            <span>Template Content</span>
                            <validation-provider #default="{ errors }" name="Content" vid="Content">
                                <quill-editor v-model="template.body" :options="editorOption">
                                    <div id="toolbar" slot="toolbar">
                                        <button class="ql-bold">Bold</button>
                                        <button class="ql-italic">Italic</button>
                                        <button class="ql-underline">Underline</button>
                                        <button class="ql-strike">Strike</button>
                                        <button class="ql-blockquote">Quote</button>
                                        <button class="ql-list" value="ordered"></button>
                                        <button class="ql-list" value="bullet"></button>
                                        <button class="ql-indent" value="-1"></button>
                                        <button class="ql-indent" value="+1"></button>
                                        <button class="ql-script" value="sub"></button>
                                        <button class="ql-script" value="super"></button>
                                        <button class="ql-background"></button>
                                        <select class="ql-font">
                                            <option selected="selected"></option>
                                            <option value="serif">serif</option>
                                            <option value="monospace">monospace</option>
                                        </select>
                                        <select class="ql-header">
                                            <option value="1">Heading 1</option>
                                            <option value="2">Heading 2</option>
                                            <option value="3">Heading 3</option>
                                            <option value="4">Heading 4</option>
                                            <option value="5">Heading 5</option>
                                            <option value="6">Heading 6</option>
                                            <option selected></option>
                                        </select>
                                        <select class="ql-align">
                                            <option selected></option>
                                            <option value="center"></option>
                                            <option value="right"></option>
                                            <option value="justify"></option>
                                        </select>
                                        <button class="ql-image">Image</button>
                                        <button class="ql-video">Video</button>
                                    </div>
                                </quill-editor>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-col>

                        <b-col cols="12" class="mb-2">
                            <b-form-group label="Upload Media" label-for="media-upload">
                                <b-form-file
                                id="media-upload"
                                multiple
                                :accept="acceptFileTypes"
                                @change="handleFileUpload"
                                ref="fileInput"
                            />                                
                            </b-form-group>
                        
                            <div v-if="previewMedia.length" class="preview-container">
                                <h5>Media Files:</h5>
                                <b-row>
                                    <b-col v-for="(media, index) in previewMedia" :key="index" cols="3" class="mb-2">
                                        <b-card class="preview-card">
                                            <!-- Image Preview -->
                                            <b-img 
                                                v-if="media.type === 'photos'"
                                                :src="media.src" 
                                                class="preview-media"
                                                alt="Preview Image"
                                            />
                        
                                            <!-- Video Preview -->
                                            <video 
                                                v-else-if="media.type === 'videos'"
                                                class="preview-media"
                                                controls
                                            >
                                                <source :src="media.src" type="video/webm" />
                                                Your browser does not support the video tag.
                                            </video>
                        
                                            <!-- <p class="text-center mt-1">{{ media.name }}</p> -->
                                            <b-button variant="danger" size="sm" class="mt-1 w-100" @click="removeImage(index)">
                                                Remove
                                            </b-button>
                                            <b-button variant="success" size="sm" class="mt-1 w-100" @click="previewImageSelected(media.src)">
                                                Preview
                                            </b-button>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        
                    </b-row>
                    <div>
                        <b-button type="submit" variant="primary" :disabled="invalid">Update</b-button>
                    </div>
                </b-form>
            </validation-observer>
        </div>
         <!-- Full Image Preview Modal -->
         <b-modal v-model="showImageModal" hide-footer hide-header centered size="lg">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="ml-2">Image Preview</h5>
                <b-button variant="danger" @click="showImageModal = false" class="mr-2">Close</b-button>
            </div>
            <b-img :src="selectedImage" class="full-image" />
        </b-modal>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BFormGroup,
    BForm,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormCheckbox,
    BFormFile,
    BContainer,
    BCard,
    BCardText,
    BSpinner,
    BImg
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import { mapActions, mapGetters } from "vuex";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { quillEditor } from "vue-quill-editor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VSelect from "vue-select";
export default {
    components: {
        BFormSelect,
        BFormFile,
        BFormGroup,
        BForm,
        BFormTextarea,
        BFormInput,
        FormWizard,
        BContainer,
        BButton,
        BFormCheckbox,
        BCard,
        TabContent,
        BRow,
        BCol,
        ToastificationContent,
        BCardText,
        BSpinner,
        quillEditor,
        ValidationProvider,
        ValidationObserver,
        BImg,
        VSelect
    },
    data() {
        return {
            id: this.$route.params.id,
            template: {
                name: null,
                platformType: [],
                subject: null,
                body: null,
                isActive: true,
                mediaFiles: []
            },
            previewImages: [],
            platformTypes: [
            ],
            showImageModal: false, // Controls modal visibility
            selectedImage: "", // Holds the image source for preview
            mediaDump: [],
            previewMedia: [],
            editorOption: {
                modules: {
                    toolbar: "#toolbar",
                },
            },
            acceptFileTypes: "image/*, video/*",
        };
    },
    methods: {
        ...mapActions("emailtemplate", ["updateContentTemplateAction", "getContentTemplateByIdAction", "getPlatformTypeAction"]),
        async formSubmitted() {
            const confirmation = await this.$swal({
        title: "Are you sure?",
        text: "Do you want to update this template?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, update it!",
        cancelButtonText: "Cancel",
        customClass: {
                confirmButton: "btn btn-success mx-2",
                cancelButton: "btn btn-secondary mx-2"
            },
        buttonsStyling: false,
    });

    if (!confirmation.value) {
        return;
    }

    let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the template is being updated',
        onOpen: () => {
            this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
    });

    try {
        let newFiles = this.template.mediaFiles.filter(file => file.file && !file.existing);

        if (!Array.isArray(this.mediaDump)) {
            try {
                this.mediaDump = JSON.parse(this.mediaDump) || [];
            } catch (e) {
                console.error("Error parsing mediaDump:", e);
                this.mediaDump = [];
            }
        }

        let payload = {
            id: this.$route.params.id,
            name: this.template.name,
            platformTypeID: this.template.platformType.map(pt => pt.value),
            subject: this.template.subject,
            content: this.template.body,
            
            mediaDetails: this.mediaDump.map(media => ({
                Path: media.Path,
                Url: media.Url,
                MediaType: media.MediaType
            })),

            description: "",
            mediaPaths: [],
            contentType: "",
            captions: {},
            templateType: '',
            
            files: newFiles.map(file => ({
                name: file.file?.name || "unknown_file",
                extension: file.file?.name?.split('.').pop() || "",
                data: file.src || "",
                user: 'Current User',
                description: file.name || 'Uploaded file',
            }))
        };

        console.log("Final Payload before sending:", JSON.stringify(payload, null, 2));

        await this.updateContentTemplateAction({ id: this.id, payload });

        loader.close();
        this.$swal({
                title: 'Email Template Updated!',
                text: 'You have successfully Updated the Template!',
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$router.push({ name: 'content-templates' });
                }
            })
    } catch (error) {
        loader.close();

        let errorMessage = error.response?.message ? JSON.stringify(error.response.data, null, 2) : error.message;
        this.$swal({
            title: 'Error!',
            html: `<pre>${errorMessage}</pre>`,
            icon: 'error',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
        });
    }
},
        success() {
            this.$swal({
                title: 'Email Template Added!',
                text: 'You have successfully added the Email Template!',
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$router.push({ name: 'content-templates' });
                }
            })
        },
        error(data) {
            let msg = null;
            if (data)
                msg = this.getErrorString(data);
            this.$swal({
                title: 'Error!',
                html: msg ?? " Failed!",
                icon: 'error',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
        },
        getErrorString(data) {
            let msg = null;
            if (data.errors) {
                let errors = data.errors;
                msg = "<div>";
                msg += "<p>Cannot post your request due to the following errors:</p>"
                for (var prop in errors) {
                    if (Object.prototype.hasOwnProperty.call(errors, prop) && prop !== "request") {
                        msg += "<p>";
                        msg += prop.replace("$.", "");
                        msg += ": ";
                        msg += errors[prop].toString().replace("$.", "");
                        msg += "</p>"
                    }
                }
                msg += "</div>";
            }
            else if (data.message) {
                msg = "<div>";
                msg += "<p>Cannot post your request due to the following errors:</p>"
                msg += data.message;
                msg += "</div>";
            }
            return msg;
        },
        async handleFileUpload(event) {
    const files = event.target.files;

      // Limit uploads to 2 files
      if (files.length > 2 || this.previewMedia.length + files.length > 2) {
        alert("You can only upload up to 2 files.");
        event.target.value = ""; // Clear file input
        return;
    }

    let newMedia = [];

    for (let file of files) {
        const base64String = await this.convertToBase64(file);
        const fileType = file.type.startsWith("image") ? "photos" : "videos";

        let newFile = {
            name: file.name || "unknown_file",
            src: base64String || "",
            file: file, 
            existing: false 
        };

        this.template.mediaFiles.push(newFile);
        newMedia.push({
            name: file.name,
            src: base64String,
            type: fileType
        });
    }

    this.previewMedia = [...this.previewMedia, ...newMedia];
    console.log("Updated Media Files:", this.template.mediaFiles);
},
previewImageSelected(imageSrc) {
        this.selectedImage = imageSrc;
        this.showImageModal = true;
    },
removeImage(index) {
    
    if (!Array.isArray(this.mediaDump)) {
        try {
            this.mediaDump = JSON.parse(this.mediaDump) || [];
        } catch (e) {
            console.error("Error parsing mediaDump:", e);
            this.mediaDump = [];
        }
    }

    const removedMedia = this.previewMedia[index];
    const filenameToRemove = removedMedia.name; 

    this.previewMedia.splice(index, 1);

    this.mediaDump = this.mediaDump.filter(media => {
        return media.Path && !media.Path.includes(filenameToRemove);
    });

    this.template.mediaFiles = this.template.mediaFiles.filter(file => file.name !== filenameToRemove);

    this.mediaDump = [...this.mediaDump]; 
    this.previewMedia = [...this.previewMedia];
    this.template.mediaFiles = [...this.template.mediaFiles];

    console.log("Updated mediaDump after removal:", this.mediaDump);
},
    convertToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); 
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }
    },
    async mounted() {
    try {
        this.$swal.fire({
            title: "Loading Template...",
            text: "Please wait while we fetch the template details.",
            allowOutsideClick: false,
            didOpen: () => {
                this.$swal.showLoading();
            }
        });

        const platformData = await this.getPlatformTypeAction();
        if (platformData) {
            this.platformTypes = platformData.map(item => ({
                value: item.id,
                text: item.platform
            }));
        }

        if (this.$route.params.id) {
            const response = await this.getContentTemplateByIdAction(this.$route.params.id);
            
            const result = response ;

            let parsedMediaDetails = [];
            try {
                parsedMediaDetails = JSON.parse(result.mediaDetails || "[]");
                this.mediaDump = (result.mediaDetails || "[]");
                console.log("mediaDump",this.mediaDump);
            } catch (e) {
                console.error("Error parsing mediaDetails:", e);
            }

            this.template = {
                name: result.name || "",
                platformType: this.platformTypes.filter(p => result.platformTypeID.includes(p.value)), // Check if value exists in array
                subject: result.subject || "",
                body: result.content || "",
                isActive: true,
                mediaFiles: parsedMediaDetails
            };

            this.previewMedia = parsedMediaDetails
                .filter(file => file.Url)
                .map(file => ({
                    name: file.Path.split('/').pop(),
                    src: file.Url,
                    type: file.MediaType 
                }));
        }

        this.$swal.close(); 
    } catch (error) {
        console.error("Error fetching template details:", error);
        this.$swal.fire({
            title: "Error!",
            text: "Failed to load template details. Please try again.",
            icon: "error",
            customClass: { confirmButton: "btn btn-primary" }
        });
    }
}



};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>

<style scoped>
label {
    font-size: 1.714rem !important;
    font-weight: 500;
    margin-bottom: 0;
}
.preview-container {
    margin-top: 20px;
}

/* Styling for preview cards */
.preview-card {
    text-align: center;
    padding: 12px;
    border-radius: 10px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    background: #ffffff;
    transition: transform 0.3s ease-in-out;
}

.preview-card:hover {
    transform: translateY(-15px);
}

/* Improved preview media (images/videos) */
.preview-media {
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 6px;
    margin-bottom: 8px;
}


.preview-image {
    width: 100px; 
    height: 100px; 
    object-fit: cover;
    border-radius: 5px; 
}

.text-truncate {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}


.swal-custom-popup .swal2-actions {
    display: flex;
    justify-content: space-between;
    gap: 20px; 
}

.swal-confirm-btn {
    padding: 8px 16px;
    font-size: 14px;
}
.swal-cancel-btn {
    padding: 8px 16px;
    font-size: 14px;
}
.full-image {
    width: 100%;
    max-height: 80vh;
    object-fit: contain;
    display: block;
    margin: auto;
}

</style>